import { ContactEntity, ContactType, SystemTeamIds } from '@jms/model';
import { SettingsPanelSelectOption } from '@workbuddy/ui/v2/blocks/settings.panel';

/** Picker group label for teams in the Shared With picker; also how a picked row is recognised as a team. */
export const QUEUE_SHARED_WITH_TEAM_GROUP = 'Team';

export interface QueueSharedWithSummary {
  /** Feed every picker toggle here; the field value is bare ids, so this is the only place a new pick's kind is known. */
  remember(option: SettingsPanelSelectOption): void;
  describe(ids: unknown): string;
}

/**
 * Summarises Shared With the way the Settings > Queues audience column does (describeQueueAudience on the API),
 * so the two never disagree about the same queue.
 */
export function createQueueSharedWithSummary(initial: ContactEntity[]): QueueSharedWithSummary {

  const teamIds = new Set(initial.filter(entry => entry.type === ContactType.Team).map(entry => entry._id));

  return {
    remember: option => {

      const isTeam = (option.data as Partial<ContactEntity> | undefined)?.type === ContactType.Team || option.group === QUEUE_SHARED_WITH_TEAM_GROUP;
      if (isTeam) teamIds.add(String(option.id));
    },
    describe: value => {

      const ids = Array.isArray(value) ? value.map(String) : [];
      if (!ids.length) return 'Select members';
      if (ids.includes(SystemTeamIds.AllEmployees)) return 'All Employees';

      const teams = ids.filter(id => teamIds.has(id)).length;
      const employees = ids.length - teams;
      return [
        employees ? `${employees} employee${employees === 1 ? '' : 's'}` : null,
        teams ? `${teams} team${teams === 1 ? '' : 's'}` : null,
      ]
        .filter(Boolean)
        .join(', ');
    },
  };
}
